import { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import {
  bgHexMap,
  colorHexMap,
  colorMap,
  ColorType,
} from "../../shared/colors";
import { ArrowBigUpDash } from "lucide-react";

const PageProgress = ({
  color,
  size = 50,
  pathWidth = 4,
}: {
  color: ColorType;
  size?: number;
  pathWidth?: number;
}) => {
  const [scroll, setScroll] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      const scrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;

      setScroll((scrollY / (documentHeight - windowHeight)) * 100);

      if (scrollY > 1) setShow(true);
      else setShow(false);
    };

    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed right-2 bottom-2 z-50 cursor-pointer group",
        show ? "block" : "hidden"
      )}
      onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
    >
      <div
        className="rounded-full flex justify-center items-center duration-1000 transition-colors"
        style={{
          background: `conic-gradient(${colorHexMap[color]} ${
            scroll * 3.6
          }deg, ${bgHexMap[color]} 0deg)`,
          width: size,
          height: size,
        }}
      >
        <div
          className={cn("absolute rounded-full ", "bg-[--background]")}
          style={{
            width: `calc(${size}px - ${pathWidth}px)`,
            height: `calc(${size}px - ${pathWidth}px)`,
          }}
        />

        <ArrowBigUpDash
          className={cn(
            "relative group-hover:scale-110 duration-300",
            colorMap[color]
          )}
        />
      </div>
    </div>
  );
};

export default PageProgress;
